import React from 'react';

const steps = [
  ['E', 'Examine', 'map what your body is signalling across all four sides of your Square of Health.'],
  ['D', 'Disrupt', 'break the load patterns keeping you stuck.'],
  ['G', 'Generate', 'rebuild your energy, focus, and recovery from the root.'],
  ['E', 'Embed', 'make it a sustainable system that holds under real-world pressure.'],
];

// The EDGE process as four connected steps on one line.
const EdgeProcess: React.FC = () => (
  <ol className="edge">
    {steps.map(([letter, name, text], index) => (
      <li key={index} className="edge__step">
        <span className="edge__letter" aria-hidden="true">
          {letter}
        </span>
        <p>
          <strong>
            {letter} — {name}:
          </strong>{' '}
          {text}
        </p>
      </li>
    ))}
  </ol>
);

export default EdgeProcess;
